module.exports = __webpack_public_path__ + "static/media/5.b4205a66.jpg";